/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_JoinInputs */

const en_header_join = /** @type {(inputs: Header_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

/**
* | output |
* | --- |
* | "Join" |
*
* @param {Header_JoinInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_join = /** @type {((inputs?: Header_JoinInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_JoinInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_join(inputs)
});